import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A vibrant showcase of independent filmmakers' music videos and short films" 
          className="hero-image" 
        />
        <p className="eyebrow">TheMusicCinema</p>
        <h1>Discover Innovative Music Videos and Short Films</h1>
        <p className="lede">
          A vibrant platform celebrating the creativity of independent filmmakers and musicians.
        </p>
        <div className="cta-row">
          <a href="/explore" className="primary">
            Explore Now
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Spotlight on Independent Filmmakers</h2>
          <p>
            Dive into the world of emerging talent and discover unique voices in film and music.
          </p>
        </article>
        <article>
          <h2>In-Depth Music Video Reviews</h2>
          <p>
            Gain insights into the artistry behind music videos with our thoughtful analyses and critiques.
          </p>
        </article>
        <article>
          <h2>Filmmaking Tips and Resources</h2>
          <p>
            Access valuable resources and advice to help you navigate your filmmaking journey.
          </p>
        </article>
        <article>
          <h2>Interviews with Artists</h2>
          <p>
            Get inspired by exclusive interviews with filmmakers and musicians sharing their creative processes.
          </p>
        </article>
        <article>
          <h2>Festival News and Opportunities</h2>
          <p>
            Stay updated on film festivals and opportunities to showcase your work and connect with others.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;